import React from 'react';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { loadPreviousStaticBuilderSection } from 'StaticBuilder/StaticBuilderActions';
import { SelfServeBuilderPopupTypes } from 'Popups';
import StaticGetLinkSection from 'StaticGetLinkSection';
import { isLastSectionGetLink } from 'StaticBuilder/Utils';
import DropDownSection from './components/DropDownSection';
import StaticCreateAccountErrorBox from './components/StaticCreateAccountErrorBox';
import NoSignatureToTemplateBuilderModal from './components/Modals/NoSignatureToTemplateBuilderModal';

export const SaveActionsEnum = {
  SAVE_AND_CONTINUE: 1,
  SAVE_AND_SHARE: 2,
  SAVE_AND_SIGN: 3,
  SAVE_SHARE_AND_SIGN: 4,
};

export class StaticRequestSignatureContentSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      action: SaveActionsEnum.SAVE_AND_CONTINUE,
      isNoSignatureToTemplateModalOpen: false,
    };

    this.onBackClick = this.onBackClick.bind(this);

    if (this.props.onClickSaveAction) {
      this.onSaveClick = this.props.onClickSaveAction.bind(this);
    } else {
      this.onSaveClick = this.onSaveClick.bind(this);
    }

    if (this.props.handleChange) {
      this.handleChange = this.props.handleChange.bind(this);
    } else {
      this.handleChange = this.handleChange.bind(this);
    }

    this.toggleNoSignatureToTemplateBuilderModal = this.toggleNoSignatureToTemplateBuilderModal.bind(this);
    this.getOptions = this.getOptions.bind(this);
  }

  onBackClick() {
    this.props.loadPreviousStaticBuilderSection();
  }

  onSaveClick(event) {
    const { documentType } = this.props;
    localStorage.removeItem(`staticSection-${window.SessionManager.id}`);
    localStorage.removeItem(`staticViewedScreens-${window.SessionManager.id}`);

    let redirectURL;

    switch (this.state.action) {
      case SaveActionsEnum.SAVE_SHARE_AND_SIGN:
        event.preventDefault();
        window._track('Me and Someone Else | Request Signature Section', documentType);
        redirectURL = `./_api/convert-static-to-freewrite.php?action=request-signature&member=1&documentType=${window.CurrentDocumentInfo.type}&ses=${window.SessionManager.hash}&key=${window.SessionManager.id}&ignoreFreeWriteToCustom=1`;
        break;
      case SaveActionsEnum.SAVE_AND_SHARE:
        event.preventDefault();
        if (this.props.redirectToTemplateBuilder) {
          window._track('Someone Else | Redirect to Template Builder', documentType);
          redirectURL = `./convert-static-to-custom-template?documentType=${window.CurrentDocumentInfo.type}&ses=${window.SessionManager.hash}&key=${window.SessionManager.id}&toolType=${SelfServeBuilderPopupTypes.SIGNATURE}`;
        } else {
          window._track('Someone Else | Request Signature Section', documentType);
          redirectURL = `./_api/convert-static-to-freewrite.php?action=request-signature&member=1&documentType=${window.CurrentDocumentInfo.type}&ses=${window.SessionManager.hash}&key=${window.SessionManager.id}&ignoreFreeWriteToCustom=1`;
        }
        break;
      case SaveActionsEnum.SAVE_AND_SIGN:
        event.preventDefault();
        window._track('Me | Request Signature Section', documentType);
        redirectURL = `./_api/convert-static-to-freewrite.php?action=sign&member=1&documentType=${window.CurrentDocumentInfo.type}&ses=${window.SessionManager.hash}&key=${window.SessionManager.id}&ignoreFreeWriteToCustom=1`;
        break;
      case SaveActionsEnum.SAVE_AND_CONTINUE:
      default: {
        window.exportStaticWithURL('No One | Request Signature Section', documentType, `export/pdf.php${window.location.search}`);
        const isFirstExport = !window.COOKIE.get('firstDocumentExported');
        const isPaid = window.User.isPaid;
        // Skip unpaid users
        if (this.props.useNoSignatureToTemplateBuilderModal && isPaid && !isFirstExport) {
          this.toggleNoSignatureToTemplateBuilderModal();
        }
        break;
      }
    }

    if (redirectURL) {
      window.location.assign(redirectURL);
    }
  }

  getOptions() {
    const { dropDownOptions } = this.props;
    let options = [
      {
        label: 'No one',
        value: `${SaveActionsEnum.SAVE_AND_CONTINUE}`,
      },
      {
        label: 'Me',
        value: `${SaveActionsEnum.SAVE_AND_SIGN}`,
      },
      {
        label: 'Someone Else',
        value: `${SaveActionsEnum.SAVE_AND_SHARE}`,
      },
      {
        label: 'Me and Someone Else',
        value: `${SaveActionsEnum.SAVE_SHARE_AND_SIGN}`,
      },
    ];

    if (dropDownOptions) {
      options = dropDownOptions;
    }
    return options;
  }

  toggleNoSignatureToTemplateBuilderModal() {
    this.setState(prevState => (
      { isNoSignatureToTemplateModalOpen: !prevState.isNoSignatureToTemplateModalOpen }
    ));
  }

  handleChange(event) {
    let action = parseInt(event.target.value, 10);
    if (isNaN(action)) {
      action = SaveActionsEnum.SAVE_AND_CONTINUE;
    }
    this.setState({
      action,
    });
  }

  render() {
    const {
      documentType,
      isLoading,
      loadPreviousStaticBuilderSection: loadPrevious,
      releaseType,
    } = this.props;
    if (isLastSectionGetLink(documentType, releaseType) && !isLoading) {
      return (
        <StaticGetLinkSection
          documentType={documentType}
          loadPreviousStaticBuilderSection={loadPrevious}
        />
      );
    }

    let postLabel = '';
    let buttonLabel = 'Save and Export';
    switch (this.state.action) {
      case SaveActionsEnum.SAVE_AND_SIGN:
        postLabel = 'Great! After you save your document, we\'ll take you straight to our signature editor.';
        buttonLabel = 'Save and Sign';
        break;
      case SaveActionsEnum.SAVE_SHARE_AND_SIGN:
        postLabel = 'Great! After you save your document, we\'ll take you straight to our signature editor. You can sign your document after your recipient(s) signs.';
        buttonLabel = 'Save and Sign';
        break;
      case SaveActionsEnum.SAVE_AND_SHARE:
        postLabel = 'Great! After you save your document, we\'ll take you straight to our signature editor. You can sign your document after your recipient(s) signs.';
        buttonLabel = 'Save and Sign';
        if (this.props.redirectToTemplateBuilder) {
          postLabel = 'Great! After you save your document, we\'ll take you to add fillable fields for your recipient to fill and sign.';
          buttonLabel = 'Save';
        }
        break;
      case SaveActionsEnum.SAVE_AND_CONTINUE:
      default:
        postLabel = 'No problem. If you change your mind, you can always add a signature later!';
    }

    if (this.props.postLabel) {
      postLabel = this.props.postLabel;
    }

    const options = this.getOptions();

    let sectionHeader = `Do you need to sign your ${this.props.documentLabel}?`;
    if (this.props.sectionHeader) {
      sectionHeader = this.props.sectionHeader;
    }

    const highlightDropDownSection = this.props.redirectToTemplateBuilder;

    return (
      <div id="screen" className="static-request-signature-content-section page">
        {
          isLoading && (
            <h3 className="static-builder-form-header-loading">Loading...</h3>
          )
        }

        {
          !isLoading && (
            <React.Fragment>
              <h2>{sectionHeader}</h2>
              {this.props.showErrorBox &&
                <StaticCreateAccountErrorBox errorMessage={this.props.errorMessage} />
              }
              { this.props.useNoSignatureToTemplateBuilderModal &&
                <NoSignatureToTemplateBuilderModal
                  isOpen={this.state.isNoSignatureToTemplateModalOpen}
                  closeModal={this.toggleNoSignatureToTemplateBuilderModal}
                />
              }
              <div className="innerContent">
                <DropDownSection
                  label={this.props.requestSignatureDropdownLabel}
                  onChange={this.handleChange}
                  options={options}
                  postLabel={postLabel}
                  showDropDown={this.props.showDropDown}
                  highlightDropDownSection={highlightDropDownSection}
                />
                {this.props.showFormAction &&
                  <div className="form-actions">
                    <button
                      className="backButton pull-left btn btn-large"
                      onClick={this.onBackClick}
                    >
                      Back
                    </button>
                    <button
                      className="pull-right btn btn-large btn-success saveButton"
                      onClick={this.onSaveClick}
                    >
                      {buttonLabel}
                    </button>
                  </div>
                }
                {this.props.children}
              </div>
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

StaticRequestSignatureContentSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  documentLabel: PropTypes.string,
  documentType: PropTypes.string,
  dropDownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  errorMessage: PropTypes.string,
  handleChange: PropTypes.func,
  isLoading: PropTypes.bool,
  loadPreviousStaticBuilderSection: PropTypes.func.isRequired,
  onClickSaveAction: PropTypes.func,
  postLabel: PropTypes.string,
  redirectToTemplateBuilder: PropTypes.bool,
  releaseType: PropTypes.string,
  requestSignatureDropdownLabel: PropTypes.string,
  sectionHeader: PropTypes.string,
  showDropDown: PropTypes.bool,
  showErrorBox: PropTypes.bool,
  showFormAction: PropTypes.bool,
  useNoSignatureToTemplateBuilderModal: PropTypes.bool,
};

StaticRequestSignatureContentSection.defaultProps = {
  children: null,
  documentLabel: '',
  documentType: '',
  dropDownOptions: null,
  errorMessage: null,
  handleChange: null,
  isLoading: false,
  onClickSaveAction: null,
  postLabel: null,
  redirectToTemplateBuilder: false,
  releaseType: '',
  requestSignatureDropdownLabel: 'Who will sign?',
  sectionHeader: null,
  showDropDown: true,
  showErrorBox: false,
  showFormAction: true,
  useNoSignatureToTemplateBuilderModal: false,
};

const mapStateToProps = ({ StaticBuilderReducer }) => ({
  releaseType: StaticBuilderReducer.fieldData.release_type,
  isLoading: StaticBuilderReducer.isLoading,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loadPreviousStaticBuilderSection,
  }, dispatch)
);

export default ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(StaticRequestSignatureContentSection);



// WEBPACK FOOTER //
// ./src-react/StaticRequestSignatureContentSection/index.jsx